import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "../../localhost/config"; //Importa la variable global

const ModalEjemplo = ({
  mostrarModal,
  cerrarModal,
  idTorneo,
  jsonResultadoFlujo,
  limpiarEquiposSeleccionados,
  limpiarBackup,
}) => {
  const [descripcion, setChangeDescripcion] = useState("");

  const manejarCambioNombre = (event) => {
    setChangeDescripcion(event.target.value);
  };

  const navigate = useNavigate();

  function guardarDatos() {
    const infoPost = {
      idTorneo: parseInt(idTorneo, 10),
      nroFecha: descripcion,
    };

    console.log(jsonResultadoFlujo);
    axios
      .post(`${API_URL}/nuevaFecha?idTorneo=${idTorneo}`, infoPost)
      .then((result) => {
        jsonResultadoFlujo?.armado.map((resultado) => {
          let fechaId = result.data.fechaId;
          let equipo1Id = resultado.equipo1.id;
          let equipo2Id = resultado.equipo2.id;
          let turnoId = resultado.idTurno.id;
          let equipo1 = resultado.equipo1.Nombre;
          let equipo2 = resultado.equipo2.Nombre;
          let dia = resultado.idTurno.Dia;
          let horario = resultado.idTurno.horario;
          let cancha = resultado.idTurno.Nombre;

          const jsonPartido = {
            fechaId: fechaId,
            equipo1Id: equipo1Id,
            equipo2Id: equipo2Id,
            turnoId: turnoId,
            equipo1: equipo1,
            equipo2: equipo2,
            dia: dia,
            horario: horario,
            cancha: cancha,
          };
          axios.post(`${API_URL}/nuevoPartido`, jsonPartido);
        });
        jsonResultadoFlujo?.noArmado.map((resultado) => {
          let fechaId = result.data.fechaId;
          let equipo1Id = resultado.equipo1.id;
          let equipo2Id = resultado.equipo2.id;
          let equipo1 = resultado.equipo1.Nombre;
          let equipo2 = resultado.equipo2.Nombre;
          let turnoId = null;
          let dia = null;
          let horario = null;
          let cancha = null;
          const jsonPartido = {
            fechaId: fechaId,
            equipo1Id: equipo1Id,
            equipo2Id: equipo2Id,
            turnoId: turnoId,
            equipo1: equipo1,
            equipo2: equipo2,
            dia: dia,
            horario: horario,
            cancha: cancha,
          };
          axios.post(`${API_URL}/nuevoPartido`, jsonPartido);
        });
      });
    limpiarEquiposSeleccionados();
    limpiarBackup();
    cerrarModal();
    navigate(`/torneo/${idTorneo}`);
  }

  return (
    <Modal show={mostrarModal} onHide={cerrarModal}>
      <Modal.Header closeButton>
        <Modal.Title>¿Desea guardar el resultado?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Ingrese un nombre para nombrarlo</p>
        <input
          type="text"
          value={descripcion}
          onChange={manejarCambioNombre}
          placeholder="Ingrese el nombre"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={guardarDatos}>
          Aceptar
        </Button>
        <Button variant="secondary" onClick={cerrarModal}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEjemplo;
